import React from 'react';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {
  mapStatusBannerChromeStyle,
  mapStatusBannerCloseButtonSx,
  mapStatusBannerContainerStyle,
  mapStatusBannerIconStyle,
  mapStatusBannerTextStyle,
} from './MapStatusBanner.styles';

/**
 * Banner flotante de estado del mapa (zoom, carga, capas de referencia).
 * `placement="inline"` omite el anclaje centrado al mapa (p. ej. callout junto a un control).
 */
export default function MapStatusBanner({
  children,
  icon,
  onClose,
  style,
  placement = 'map',
  closeAriaLabel = 'Cerrar aviso',
}) {
  const baseStyle = placement === 'inline'
    ? mapStatusBannerChromeStyle
    : mapStatusBannerContainerStyle;

  return (
    <div
      style={{ ...baseStyle, ...(style || {}) }}
      role="status"
      aria-live="polite"
    >
      {icon ? (
        <span style={mapStatusBannerIconStyle} aria-hidden="true">
          {icon}
        </span>
      ) : null}
      <span style={mapStatusBannerTextStyle}>{children}</span>
      {onClose ? (
        <IconButton
          size="small"
          onClick={onClose}
          aria-label={closeAriaLabel}
          sx={mapStatusBannerCloseButtonSx}
        >
          <CloseIcon sx={{ fontSize: 12 }} />
        </IconButton>
      ) : null}
    </div>
  );
}
